export interface PaginationModel {
  previous: string;
  next: string;
  total: number;
  start: number;
  nb_items: number;
  limit: number;
  urlBaseOverride: string;
  paginationDirection: PaginationDirection;
}

export enum PaginationDirection{
  next = 'next',
  previous = 'previous',
}
